import React from 'react';
import MetricInfoPopover, { type MetricInfoDefinition } from '../ui/MetricInfoPopover';

type InsightsSectionHeaderProps = {
  title: string;
  info?: MetricInfoDefinition;
  actions?: React.ReactNode;
};

const InsightsSectionHeader: React.FC<InsightsSectionHeaderProps> = ({ title, info, actions }) => (
  <div className="mb-4 flex items-center justify-between gap-3">
    <div className="flex min-w-0 items-center gap-2">
      <h3 className="text-sm font-semibold text-gray-900 dark:text-white">{title}</h3>
      {info && <MetricInfoPopover title={title} info={info} />}
    </div>
    {actions}
  </div>
);

export default InsightsSectionHeader;
